import * as React from "react";
import styled from "styled-components";

import { Tabs } from "@ui/Molecules/Tabs";

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const HeaderTabs = (props: Props): React.ReactElement => (
  <StyledHeaderTab variant="links" className={props.className}>
    {props.children}
  </StyledHeaderTab>
);

const StyledHeaderTab = styled(Tabs)`
  display: none;

  ${props => props.theme.breakpoints.desktop} {
    display: block;
    margin: ${props => props.theme.margins.base_x4} 0
      ${props => props.theme.margins.base_x3};
  }
`;

export { HeaderTabs };
